import { Link } from '@inertiajs/react';

type SdgIcon = {
    sdg_number: number;
    short_title: string;
    slug: string;
    image?: string | null;
};

type SdgIconStripProps = {
    sdgs?: SdgIcon[];
    className?: string;
    iconClassName?: string;
};

export default function SdgIconStrip({
    sdgs = [],
    className = 'mb-4 flex flex-wrap gap-2.5',
    iconClassName = 'h-8 w-8 rounded-sm',
}: SdgIconStripProps) {
    const visibleSdgs = sdgs.filter((sdg) => sdg.image);

    if (visibleSdgs.length === 0) {
        return null;
    }

    return (
        <div className={className}>
            {visibleSdgs.map((sdg) => (
                <Link
                    key={sdg.slug}
                    href={route('sdg.show', { sdg: sdg.slug })}
                    prefetch
                    className="inline-flex shrink-0 transition-transform duration-200 hover:-translate-y-0.5"
                    aria-label={`SDG ${sdg.sdg_number}: ${sdg.short_title}`}
                    title={`SDG ${sdg.sdg_number}: ${sdg.short_title}`}
                >
                    <img src={sdg.image ?? ''} alt={`SDG ${sdg.sdg_number}`} className={`${iconClassName} object-cover shadow-sm`} />
                </Link>
            ))}
        </div>
    );
}
